import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Header.css';
import Brand from '../Brand';
import Navigation from './Navigation';

class Header extends React.Component {
  render() {
    return (
      <div className={s.root}>
        <div className={cx(s.container, 'clearfix')}>
          <Navigation />
          <Brand />
        </div>
      </div>
    );
  }
}

export default withStyles(s)(Header);



// WEBPACK FOOTER //
// ./src/components/Header/Header.js